import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import TrailerSection from "./components/TrailerSection";
import FeaturesSection from "./components/FeaturesSection";
import ElementsSection from "./components/ElementsSection";
import StatsSection from "./components/StatsSection";
import BetaSection from "./components/BetaSection";
import Footer from "./components/Footer";
import AdminPage from "./components/AdminPage";
import GalleryPage from "./components/GalleryPage";
import { Toaster } from "./components/ui/sonner";
import { SiteContentProvider } from "./context/SiteContentContext";

const Home = () => {
  return (
    <SiteContentProvider>
      <div>
        <Navbar />
        <HeroSection />
        <TrailerSection />
        <StatsSection />
        <FeaturesSection />
        <ElementsSection />
        <BetaSection />
        <Footer />
        <Toaster />
      </div>
    </SiteContentProvider>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<><AdminPage /><Toaster /></>} />
          <Route path="/gallery" element={<><GalleryPage /><Toaster /></>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
